/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { hasPath, path } from 'ramda';
import { Controller, useFormContext } from 'react-hook-form';

const UserInfoForm = () => {
	const {
		formState: { errors },
		control
	} = useFormContext();

	return (
		<Container component="main" maxWidth="lg">
			<CssBaseline />
			<Grid container spacing={1}>
				<Grid item xs={12} sm={6}>
					<Controller
						name="first_name"
						control={control}
						render={({ field }) => {
							return (
								<TextField
									fullWidth
									autoFocus
									{...field}
									variant="outlined"
									label="First Name"
									helperText={path(['first_name', 'message'], errors)}
									error={hasPath(['first_name', 'message'], errors)}
								/>
							);
						}}
					/>
				</Grid>
				<Grid item xs={12} sm={6}>
					<Controller
						name="last_name"
						control={control}
						render={({ field }) => {
							return (
								<TextField
									fullWidth
									{...field}
									variant="outlined"
									label="Last Name"
									helperText={path(['last_name', 'message'], errors)}
									error={hasPath(['last_name', 'message'], errors)}
								/>
							);
						}}
					/>
				</Grid>
				<Grid item xs={12}>
					<Controller
						name="organization"
						control={control}
						render={({ field }) => {
							return (
								<TextField
									fullWidth
									{...field}
									variant="outlined"
									label="Organization"
									helperText={path(['organization', 'message'], errors)}
									error={hasPath(['organization', 'message'], errors)}
								/>
							);
						}}
					/>
				</Grid>
				<Grid item xs={12}>
					<Controller
						name="email"
						control={control}
						render={({ field }) => (
							<TextField
								fullWidth
								{...field}
								variant="outlined"
								label="Email"
								type="email"
								helperText={path(['email', 'message'], errors)}
								error={hasPath(['email', 'message'], errors)}
							/>
						)}
					/>
				</Grid>
			</Grid>
		</Container>
	);
};

export default UserInfoForm;
